import { useEffect, useRef, useState } from 'react';
import { Alert } from '@skupreme/shared/ui';
import { GOOGLE_CLIENT_ID } from '../env';
import { renderGoogleButton } from './google';

export function GoogleButton({
  onCredential,
}: {
  onCredential: (idToken: string) => void;
}) {
  const slot = useRef<HTMLDivElement>(null);
  const callback = useRef(onCredential);
  callback.current = onCredential;
  const [error, setError] = useState<string | null>(
    GOOGLE_CLIENT_ID ? null : 'Google sign-in is not configured.',
  );

  useEffect(() => {
    if (!GOOGLE_CLIENT_ID || !slot.current) {
      return;
    }
    renderGoogleButton(slot.current, idToken =>
      callback.current(idToken),
    ).catch((cause: Error) => setError(cause.message));
  }, []);

  return (
    <>
      <div ref={slot} />
      {error && <Alert tone="danger">{error}</Alert>}
    </>
  );
}
